import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["block", "checked", "children", "classes", "disabled", "id", "name", "onChange", "textProps", "theme", "value"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { CheckCircleFilled } from "../icons";
import { TextBase } from "../internal/TextBase";
import styles from './CheckboxButton.css';
var cx = classNames.bind(styles);
var defaultClasses = {};
var defaultTextProps = {};
export var CheckboxButton = /*#__PURE__*/forwardRef(function CheckboxButton(_ref, ref) {
  var block = _ref.block,
      checked = _ref.checked,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultClasses : _ref$classes,
      disabled = _ref.disabled,
      id = _ref.id,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? defaultTextProps : _ref$textProps,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("label", _extends({}, rest, {
    className: cx('root', "theme_".concat(theme), {
      block: block
    }, classes.root)
  }), /*#__PURE__*/React.createElement("input", {
    className: cx('input'),
    checked: checked,
    disabled: disabled,
    type: "checkbox",
    value: value,
    ref: ref,
    id: id,
    name: name,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('box', classes.box)
  }, checked && /*#__PURE__*/React.createElement("span", {
    className: cx('check')
  }, /*#__PURE__*/React.createElement(CheckCircleFilled, {
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement(TextBase, _extends({}, textProps, {
    as: "span",
    color: disabled ? 'N100' : 'N900',
    size: "l"
  }), children)));
});
export default CheckboxButton;